import React from 'react';

import { QStack, QText } from '@captivateiq/quotient';

type ErrorMessageProps = {
  message?: string;
};
export const ErrorMessage = ({ message }: ErrorMessageProps) => {
  return (
    <QStack
      direction="row"
      sx={{
        alignItems: 'center',
        backgroundColor: 'error.light',
        border: '1px solid',
        borderColor: 'error.main',
        borderRadius: '8px',
        justifyContent: 'stretch',
        padding: '12px',
      }}
    >
      <QText
        sx={{
          color: 'error.dark',
          fontSize: '12px',
          fontWeight: 400,
          lineHeight: '20px',
        }}
      >
        {message || 'An unknown error occurred.'}
      </QText>
    </QStack>
  );
};
